/*** IMPORTS FROM imports-loader ***/
var global = window;

import tagTester from './_tagTester.js';

export default tagTester('WeakSet');

